<script setup lang="ts">
import IconBolt from '~icons/girassol/bolt-fill'

const { t } = useI18n()
</script>

<template>
  <aside
    id="alert-turbo-prime"
    class="turbo-prime-alert"
    data-testid="alert-turbo-prime"
    role="status"
  >
    <span
      class="turbo-prime-alert__icon"
      aria-hidden="true"
    >
      <IconBolt class="turbo-prime-alert__bolt" />
    </span>
    <div>
      <p class="turbo-prime-alert__title">
        {{ t('header.project.turbo.alert.title_before') }}
        <strong>{{ t('header.project.turbo.alert.title_emphasis') }}</strong>
        {{ t('header.project.turbo.alert.title_after') }}
      </p>
      <p class="turbo-prime-alert__description">
        {{ t('header.project.turbo.alert.description') }}
      </p>
    </div>
  </aside>
</template>

<style lang="scss" scoped>
.turbo-prime-alert {
  @apply flex items-center gap-4xs rounded-lg p-2xs my-4;
  @apply bg-highlight-light bg-opacity-intense;
  @apply border border-solid border-highlight-medium;
  @apply text-highlight-dark;

  &__icon {
    @apply flex items-center justify-center flex-shrink-0;
    @apply w-10 h-10 rounded-md bg-highlight-pure text-feedback-warning-pure;
    @apply shadow-weak;
  }

  &__bolt {
    @apply w-5 h-5;
  }

  &__title {
    @apply fonts-body-large-bold mb-quark;

    strong {
      @apply font-bold not-italic;
    }
  }

  &__description {
    @apply fonts-body-medium-regular;
  }
}
</style>
